"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCalloutColors = exports.toHex = exports.DEFAULT_ACCENT = void 0;
const ui_1 = require("@jsonjoy.com/ui");
const RgbColor_1 = require("@jsonjoy.com/ui/lib/styles/color/RgbColor");
exports.DEFAULT_ACCENT = '#07f';
/** Format any CSS color string as `#RRGGBB(AA)`. */
const toHex = (css) => {
    const rgb = RgbColor_1.RgbColor.fromString(css);
    if (rgb)
        return rgb.hex();
    const hsl = ui_1.HslColor.from(css);
    return hsl ? hsl.toRgb().hex() : css;
};
exports.toHex = toHex;
/**
 * Resolve all callout-related colors from a single accent string. Accepts hex
 * or anything `HslColor.from` understands. Falls back to `DEFAULT_ACCENT` on
 * unparseable input.
 */
const getCalloutColors = (styles, accent) => {
    const hsl = ui_1.HslColor.from(accent) ?? ui_1.HslColor.from(exports.DEFAULT_ACCENT);
    const surface = styles.light ? ui_1.HslColor.from('#fff') : ui_1.HslColor.from('#000');
    const themed = new ui_1.ThemeColor(hsl.norm(), surface);
    const titleHsl = (ui_1.HslColor.from(accent) ?? ui_1.HslColor.from(exports.DEFAULT_ACCENT))
        .toLinearRgb()
        .adjToContrast(new ui_1.LinearRgbColor(1, 1, 1));
    const shadow = themed.fg.copy();
    shadow.a = 0.08;
    return {
        accent: themed.toString(),
        bg: themed.g(0.02),
        bgHover: themed.g(0.04),
        bd: themed.col(0.16).fg.pct(0, -0.5).toString(),
        bdHover: themed.col(0.22).fg.pct(0, -0.5).toString(),
        shadow: shadow.toString(),
        title: titleHsl.toString(),
    };
};
exports.getCalloutColors = getCalloutColors;
